class archiveSeatplan {
    constructor(Alert, $http, $state) {

        this.key = 'archive-seatplan';
        this.title = 'Archive';
        this.level = 'highlight';
        this.icon = 'fal fa-trash-alt';
        this.alert = Alert;
        this.api = $http;
        this.state = $state;
    }

    action(seatplan, vm) {
        this.alert.confirm({
            title: `Deleting ${ seatplan.title}`,
            message: 'Are you sure you want to move this Seatplan to trash?',
            confirmBtn: 'Delete'
        }).then(() => {
            return this.api.delete(`seatplans/${ seatplan.id }`)
                .then(() => {
                    this.state.reload();
                    if (vm.store) {
                        return vm.store.dispatch('getData');
                    }
                }, err => this.alert.handle(err));
        }, () => ({}))
    }

}

angular
    .module('festzelt-os.seatplans')
    .factory('archiveSeatplan', [
        'Alert',
        '$http',
        '$state',
        (Alert, $http, $state) => new archiveSeatplan(Alert, $http, $state)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/workflows/archive-seatplan.js